import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VideoDialogComponent } from '../video-dialog/video-dialog.component';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-tools',
    templateUrl: './tools.component.html',
    styleUrls: ['./tools.component.css'],
    imports: [MrpScrolltopComponent, MatIconButton, MatIcon]
})
export class ToolsComponent implements OnInit {

  isBrowser = false;

  constructor(private dialog: MatDialog, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) this.logPage("Tools");
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }


  openVideoPlayer(index: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false; 
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80vw'; 
    dialogConfig.height = '70vh'; 

    // ✅ Pass the index using the `data` property
    // THIS IS AN INPUT TO VideoDialogComponent
    dialogConfig.data = { videoIndex: index };

    this.dialog.open(VideoDialogComponent, dialogConfig);
  }

}
